export interface CloseDecision {
  shouldReconnect: boolean;
  reason: string;
}

export const decideReconnectForCloseCode = (code: number, initiatedByClient: boolean): CloseDecision => {
  if (initiatedByClient) {
    return { shouldReconnect: false, reason: 'client_initiated' };
  }
  if (code === 1000) {
    return { shouldReconnect: false, reason: 'normal_close' };
  }
  if (code === 1008) {
    // Policy violation / invalid session (e.g. expired ticket). Retrying usually loops forever.
    return { shouldReconnect: false, reason: 'policy_violation' };
  }
  if (code === 1006 || code === 1011 || code === 1012 || code === 1013) {
    return { shouldReconnect: true, reason: 'transient_or_upstream' };
  }
  return { shouldReconnect: true, reason: 'default_reconnect' };
};
